import { UserRole } from 'common/types'
import { FC, ReactNode } from 'react'
import { useWorkflowUser } from 'room/common/use-workflow-user'
import { useSessionMode } from 'session-mode/use-session-mode'
import { RecordingStateScope } from './recording-context'
import RecordingResumePrompt from './recording-resume-prompt'

/**
 * Recording state for whoever gets the trainer UI. Decided by the workflow
 * role - the same rule the rooms use to render the trainer menus (with their
 * Recording item) and useAutomaticRecordingTransition uses to pause. It is
 * known from the first render; session-planning's training info (useIsTrainer)
 * can still be loading when the trainer lands straight in the training room,
 * which left the Recording item without its provider.
 *
 * Never in person: a stationary interaction scheme enables no ParamToggler,
 * so there is nothing to record and nothing to resume. The trainer menu shows
 * its Recording item only where this provides recording state.
 *
 * The room below keeps its place in the tree whichever way this goes - see
 * `RecordingStateScope`.
 */
const RecordingStateController: FC<{ children: ReactNode }> = ({
	children,
}) => {
	const workflowUser = useWorkflowUser()
	const inPerson = useSessionMode() === 'IN_PERSON'

	return (
		<RecordingStateScope
			active={workflowUser?.role === UserRole.UPPER_ECHELON && !inPerson}
		>
			{children}
			<RecordingResumePrompt />
		</RecordingStateScope>
	)
}

export default RecordingStateController
